import { createAction, props } from '@ngrx/store';
import { EquipmentProjectApiModel } from '@/core/models/api/equipment-project-api-model.model';

// Load
export const loadEquipmentProjectsByProject = createAction(
  '[EquipmentProject] Load By Project',
  props<{ projectId: number }>()
);
export const loadEquipmentProjectsByProjectSuccess = createAction(
  '[EquipmentProject] Load By Project Success',
  props<{ items: EquipmentProjectApiModel[]; projectId: number }>()
);
export const loadEquipmentProjectsByProjectFailure = createAction(
  '[EquipmentProject] Load By Project Failure',
  props<{ error: any }>()
);

// Add Multiple
export const addEquipmentProjects = createAction(
  '[EquipmentProject] Add Multiple',
  props<{ items: EquipmentProjectApiModel[] }>()
);
export const addEquipmentProjectsSuccess = createAction(
  '[EquipmentProject] Add Multiple Success',
  props<{ items: EquipmentProjectApiModel[] }>()
);
export const addEquipmentProjectsFailure = createAction(
  '[EquipmentProject] Add Multiple Failure',
  props<{ error: any }>()
);

// Update
export const updateEquipmentProject = createAction(
  '[EquipmentProject] Update',
  props<{ item: EquipmentProjectApiModel }>()
);
export const updateEquipmentProjectSuccess = createAction(
  '[EquipmentProject] Update Success',
  props<{ item: EquipmentProjectApiModel }>()
);
export const updateEquipmentProjectFailure = createAction(
  '[EquipmentProject] Update Failure',
  props<{ error: any }>()
);

// Delete
export const deleteEquipmentProject = createAction(
  '[EquipmentProject] Delete',
  props<{ id: number }>()
);
export const deleteEquipmentProjectSuccess = createAction(
  '[EquipmentProject] Delete Success',
  props<{ id: number }>()
);
export const deleteEquipmentProjectFailure = createAction(
  '[EquipmentProject] Delete Failure',
  props<{ error: any }>()
);
